<template lang="pug">
v-btn.g-btn(v-bind="{ ...$attrs, color, depressed, disabled, outlined, text }" :style="newStyles" v-on="$listeners")
  slot
</template>

<script>
export default {
  name: 'GButton',
  props: {
    color: {
      type: String,
    },
    depressed: {
      type: Boolean,
      default: true,
    },
    outlined: {
      type: Boolean,
      default: false,
    },
    text: {
      type: Boolean,
      default: false,
    },
    fill: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({}),
  computed: {
    newStyles() {
      const styles = {};
      if(this.fill) styles.backgroundColor = this.fill;
      return styles;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "Button.scss";
</style>
